import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { VideoOverlayIconComponent } from '@/components/video-overlay-icon/video-overlay-icon';
import { useDataAnalytics } from '@/hooks/analytics/analytics';
import { PromoContent } from '@cinemark/content-api-client';
import Image from 'next/image';
import promotionalVideoDialogStyles from './promotional-video-dialog.module.scss';

type PromotionalVideoDialogProps = {
  dataLinkCategory: string;
  dataLinkName?: string;
  promoContent: PromoContent;
};

export const PromotionalVideoDialog = ({ dataLinkCategory, dataLinkName, promoContent }: PromotionalVideoDialogProps): React.JSX.Element | null => {
  const { trackClick } = useDataAnalytics();

  if (!promoContent?.url) {
    return null;
  }

  const thumbnailImage = promoContent.mediumImage || promoContent.smallImage || promoContent.largeImage;

  return (
    <div className="relative"
      style={thumbnailImage?.height && thumbnailImage?.width ? { height: `${thumbnailImage.height}px`, width: `${thumbnailImage.width}px` } : undefined}
    >
      {thumbnailImage &&
        <Image alt={promoContent.altText || 'Promotional Video Thumbnail'}
          className="w-full h-full object-cover rounded-md"
          height={thumbnailImage.height}
          src={thumbnailImage.url || '/img/poster_blank.jpg'}
          width={thumbnailImage.width}
        />
      }

      <Dialog>
        <DialogTrigger onClick={() => trackClick({
          linkCategory: dataLinkCategory,
          linkName: dataLinkName || `Promotional Video Click ${promoContent.promoTitle}`,
        })}
        >
          <VideoOverlayIconComponent height="auto"
            width="40%"
          />
        </DialogTrigger>

        <DialogContent className={promotionalVideoDialogStyles['modal-content']}>
          <DialogHeader showCloseButton={false}>
            <DialogTitle className="hide" />
            <DialogDescription className="hide" />
          </DialogHeader>

          <div className="relative w-full aspect-video -mt-4">
            <iframe allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              className="absolute top-0 left-0 w-full h-full"
              src={promoContent.url}
              title={promoContent.promoTitle || 'External Video'}
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
